import { useState } from 'react';
import ClearIcon from "@mui/icons-material/Clear";
import { CircularProgress, FormControl, FormControlLabel, FormLabel, Grid, Radio, RadioGroup} from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import { useFormik } from 'formik';
import * as yup from "yup";
import { useSelector } from "react-redux";

import { LoadingButton } from '@mui/lab';
import { apiput } from '../../service/api';

const Edit = (props) => {
    const { open, handleClose, setUserAction, errorData, fetchError } = props
    const [isLoading, setIsLoading] = useState(false);
    const userDetails = useSelector((state) => state?.userDetails?.data)
    // -----------  validationSchema
    const validationSchema = yup.object({
        resolved: yup.boolean().required("Resolved is required"),
    });

    // -----------   initialValues
    const initialValues = {
        resolved: errorData?.resolved,
    };

    // edit Error api
    const editError = async (values) => {
        setIsLoading(true)
        try {
            const data = values;
            const result = await apiput(`api/errors/edit/${errorData?._id}`, data)
            setUserAction(result)
            if (result && result.status === 200) {
                handleClose();
                fetchError();
            }

        } catch (error) {
            console.log(error);
        }
        setIsLoading(false)

    }


    // formik
    const formik = useFormik({
        initialValues,
        validationSchema,
        validate: (values) => {
            const errors = {};
            if (values.resolved === 'Yes' && !values.vehicleRegistrationNumber)
                errors.vehicleRegistrationNumber = 'Vehicle Registration Number is required';
            return errors;
        },
        enableReinitialize: true,
        onSubmit: async (values) => {
            const errorData = {
                resolved: values.resolved,
                modifiedOn: new Date(),
            }
            editError(errorData)
        },
    });
    
    // useEffect(() => {
    //     if (userDetails?.length === 0) {
    //         dispatch(fetchUserData())
    //     }
    // }, [open]);

    return (
        <div>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
            >
                <DialogTitle
                    id="scroll-dialog-title"
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                    }}
                >
                    <Typography variant="h6">Edit</Typography>
                    <Typography>
                        <ClearIcon
                            onClick={handleClose}
                            style={{ cursor: "pointer" }}
                        />
                    </Typography>
                </DialogTitle>
                <DialogContent dividers>
                    <form>
                        <DialogContentText
                            id="scroll-dialog-description"
                            tabIndex={-1}
                        >
                            <Typography style={{ marginBottom: "15px" }} variant="h6">
                                Error Details
                            </Typography>
                            <Grid
                                container
                                rowSpacing={3}
                                columnSpacing={{ xs: 0, sm: 5, md: 4 }}
                            >
                                <Grid item xs={12} sm={6} md={6}>
                                    <FormControl fullWidth>
                                        <FormLabel>Resolved <span style={{ color: "red" }}>*</span></FormLabel>
                                        <Radio
                                            checked={formik.values.resolved === true}
                                            onChange={() => formik.setFieldValue("resolved", true)}
                                        />
                                        <Radio
                                            checked={formik.values.resolved === false}
                                            onChange={() => formik.setFieldValue("resolved", false)}
                                        />
                                        <RadioGroup
                                            row
                                            aria-labelledby="demo-row-radio-buttons-group-label"
                                            name="resolved"
                                            value={formik.values.resolved || true}
                                            error={formik.touched.resolved && Boolean(formik.errors.resolved)}
                                            onChange={formik.handleChange}
                                        >
                                        <FormControlLabel value={true} control={<Radio />} label="Yes" />
                                        <FormControlLabel value={false} control={<Radio />} label="No" />
                                    </RadioGroup>
                                    </FormControl>
                                </Grid>
                            </Grid>

                        </DialogContentText>
                    </form>
                </DialogContent>
                <DialogActions>
                    <LoadingButton onClick={formik.handleSubmit} variant='contained' color='primary' disabled={!!isLoading}>
                        {isLoading ? <CircularProgress size={27} /> : 'Save'}
                    </LoadingButton>                    <Button onClick={() => {
                        formik.resetForm()
                        handleClose()
                    }} variant='outlined' color='error'>Cancel</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default Edit